import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import dotenv from 'dotenv'
import VueMq from "vue-mq";

dotenv.config()

Vue.config.productionTip = false
//Vue.loadScript("js/speedtest.js")

Vue.use(VueMq, {
  breakpoints: {
    //ssmartphone: 600,
    smartphone: 1000,
    computer: Infinity,
  }
})

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
